<template>
  <Transition name="fade" appear>
    <div class="container">
      <div class="video-wrapper">
        <div class="video">
          <ExpanderVideo :filename="item[0]" :autoplay="true" :url="item[1]" :name="item[2]" />
          <button class="close" @click="close()"><img src="@/assets/close.svg" alt="Close"></button>
        </div>
      </div>
      <button class="close-bg" @click="close()"></button>
    </div>
  </Transition>
</template>

<script>
import ExpanderVideo from './ExpanderVideo.vue'
  
  export default {
    name: 'DiscoveryVideoModal',
    components: {
      ExpanderVideo,
    },
    props: {
      item: { type: Array, required: true }
    },
    emits: ['closeModal'],
    methods: {
      close() {
        this.$emit('closeModal')
      }
    },
  }
</script>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  .container {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    background: rgba(#000, .5);
    display: flex;
    justify-content: center;
    align-items: center;
    .video-wrapper {
      position: relative;
      z-index: 2;
      width: 90%;
      max-width: 1000px;
    }
    .video {
      border-radius: 0.625rem;
      border: .1875rem solid #BC9C64;
      overflow: hidden;
      @include d {
        border-width: .3125rem;
      }
    }
    .close {
      position: absolute;
      right: 0;
      top: -3rem;
      width: 2rem;
      opacity: .75;
      transition: .15s;
      &:hover {
        opacity: 1;
      }
    }
    .close-bg {
      @include cover;
      z-index: 1;
    }
  }


  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }


</style>
